;(function ( $ ) {

    /**
     *  formSingleSteps
     *  transform form to only display one field at time
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'formSingleSteps';
    var defaults = {
        scrollEasing: 'easeInOutCubic',
        scrollDuration: 300,
        scrollOffset: 160
    };

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {

        init: function () {
            if ($('html').hasClass('touch')) {
                // single-step-form does not work well on touch devices
                return;
            }
            this.$overlayContainer = $(this.element).parents('.overlay-content');
            if (!this.$overlayContainer.length) {
                // only display as single-step-form if inside an overlay
                return;
            }
            this.$overlay = $(this.element).parents('#atp-overlay');
            this.activeNextFired = false;
            this.activeRowIndex = 0;
            this.$formRows = $(this.element).find('.form-row');

            this.$formRows.each(function(index, elem) {
                if (index) { // no extra padding for first row
                    $(this).css({
                        'padding-top': '20px',
                        'min-height': '160px'
                    });
                }
            });

            this.setRowIndexes();
            this.showProgressBar();
            this.registerEvents();
        },

        registerEvents: function() {
            var _this = this;
            var scrollTop = 0;
            var rowIndex = 0;
            this.$overlayContainer.on('scroll', function() {
                if (_this.disableScrollHandler) return;
                scrollTop = $(this).scrollTop();
                if (scrollTop <= 100) {
                    rowIndex = 1;
                } else {
                    rowIndex = Math.round(scrollTop / _this.settings.scrollOffset) + 1;
                }
                if (rowIndex > _this.$formRows.length - 1 ) {
                    rowIndex = _this.$formRows.length - 1;
                }
                if (rowIndex === 0 ) {
                    rowIndex = 1;
                }
                _this.activateRowByIndex(rowIndex);
            });
            $(this.element).find('input').on('focus', function() {
                _this.activateRow($(this).parents('.form-row'));
            });
            $(this.element).find('.select2').on('select2:open', function() {
                _this.activateRow($(this).parents('.form-row'));
            });
            $(this.element).find('select').on('change', function() {
                _this.activateNextRow();
            });

            // Keyboard events
            $(window).off('keydown');
            $(window).on('keydown', function(e) { // intercept some keyboard events
                switch (e.keyCode) {
                    case 9: // tab
                        e.preventDefault();
                        if (e.shiftKey) {
                            _this.activatePrevRow();
                        } else {
                            _this.activateNextRow();
                        }
                        break;
                    case 13: // enter
                        e.preventDefault();
                        if ($(_this.element).find('.form-row.active').find('button[type="submit"]').length) {
                            $(_this.element).submit();
                        }
                        if ($(_this.element).find('.form-row.active').find('.show-ticket-preview').length) {
                            $(_this.element).find('.form-row.active').removeClass('active');
                            $(window).trigger('form.validate-do');
                        } else {
                            _this.activateNextRow();
                        }
                        break;
                }
            });
            $(window).on('atp-form.rowtoggle', function() {
                _this.setRowIndexes();
                _this.activateFirstRow();
            });

            $(window).on('form.has-errors', function() {
                var $errorRow = $(_this.element).find('fieldset.has-error').first().parents('.form-row');
                _this.scrollToIndex($errorRow.data('index'));
            });

            $(window).on('ticketpreview.show', function() {
                _this.setProgressBarStep();
            });

            $(window).on('ticketform.show', function() {
                _this.setProgressBarStep();
            });

            $(this.element).on('submit', function(e) {
                if ($(this).find('.has-error').length) {
                    e.preventDefault();
                }
            });
        },

        setRowIndexes: function() {
            this.$formRows = $(this.element).find('.form-row:not(.is-hidden)');
            this.$formRows.each(function(index, elem) {
                $(this).data('index', index);
            });
        },

        activateFirstRow: function() {
            var $row = $(this.element).find('.form-row:not(.is-hidden)').eq(1);
            this.activateRow($row);
            this.scrollToIndex(1);
            this.setProgressBarStep();
        },

        activateRow: function($row) {
            $(this.element).find('.form-row.active').removeClass('active');
            $row.addClass('active');
            this.activeRowIndex = $row.data('index');
            this.setProgressBarStep();
        },

        activateNextRow: function() {
            var _this = this;
            if (this.activeNextFired) return;
            var $currentRow = $(this.element).find('.form-row.active');
            // check if row is valid
            var ok = this.validateField($currentRow.find('input, select').first());
            if (!ok) return;

            $currentRow.removeClass('active');
            var $next = $currentRow.next();
            $next.addClass('active');
            this.scrollToIndex($next.data('index'));

            // prevent multiple activations
            this.activeNextFired = true;
            window.setTimeout(function() {
                _this.activeNextFired = false;
            }, 50);
            this.setProgressBarStep();
        },

        activatePrevRow: function() {
            var $currentRow = $(this.element).find('.form-row.active');
            if ($currentRow.data('index') <= 1) return;
            $currentRow.removeClass('active');
            var $prev = $currentRow.prev();
            $prev.addClass('active');
            this.scrollToIndex($prev.data('index'));
            this.setProgressBarStep();
        },

        activateRowByIndex: function(rowIndex) {
            var $activeRow = null;
            if (rowIndex !== this.activeRowIndex) {
                $(this.element).find('.form-row.active').removeClass('active');
                $activeRow = $(this.element).find('.form-row:not(.is-hidden)').eq( rowIndex );
                $activeRow.addClass('active');
                $activeRow.find('input, select').first().focus();
                this.activeRowIndex = rowIndex;
                this.setProgressBarStep();
            }
        },

        scrollToIndex: function(index) {
            var _this = this;
            this.$overlayContainer.animate({
                'scrollTop': (index - 1) * this.settings.scrollOffset
            }, this.settings.scrollDuration, this.settings.scrollEasing, function() {
                _this.setProgressBarStep();
            });
        },

        showProgressBar: function() {
            if (!this.$overlay.find('.form-step-progress').length) {
                var html = '<div class="form-step-progress">' +
                    '<div class="form-step-progress-bar-wrapper"><div class="form-step-progress-bar bg-color-event"></div></div>' +
                    '<div class="form-step-progress-steps"><span class="form-step-progress-step-current color-event"></span>/<span class="form-step-progress-step-total"></span></div>' +
                    '</div>';
                this.$overlay.append(html);
            }
            this.$progressBar = this.$overlay.find('.form-step-progress');
            this.$progressBar.show();
            this.setProgressBarStep();
        },

        setProgressBarStep: function() {
            var steps = this.$formRows.length;
            if (!$(this.element).find('.form-ticket-preview').length) {
                steps = steps - 1;
            }
            var activeIndex = this.activeRowIndex;
            if (!activeIndex) {
                activeIndex = 1;
            }
            if ($(this.element).find('.form-ticket-preview:visible').length) {
                activeIndex = steps;
            }
            this.$progressBar.find('.form-step-progress-step-current').text(activeIndex);
            this.$progressBar.find('.form-step-progress-step-total').text(steps);
            this.$progressBar.find('.form-step-progress-bar').width( 100 / steps * activeIndex + '%');
        },

        validateField: function($input) {
            if ($input.hasClass('required') && !$input.val()) {
                $input.trigger('required-msg.show');
                return false;
            }
             if ($input.hasClass('validate') && $input.val()) {
                if ($input.hasClass('validate-email')) {
                    var expr = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
                    if (!expr.test($input.val())) {
                        $input.trigger('validate-msg.show');
                        return false;
                    }
                }
            }
            return true;
        }
    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
